<template>
  <div class="million-read-report-my-harvest">
    <div class="million-read-report-my-harvest-header">
      <div class="million-read-report-my-harvest-header-title">
        <span>{{ harvest.blockTitle }}</span>
      </div>
    </div>
    <div class="million-read-report-my-harvest-list">
      <div class="million-read-report-my-harvest-item"
           v-for="(item, index) in harvest.list"
           :key="index"
      >
        <div class="million-read-report-my-harvest-item-title"
             v-html="item.title"
        ></div>
        <div class="million-read-report-my-harvest-item-content"
             v-html="item.content"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
  import validator from '@/utils/validator';

  export default {
    name: 'MillionReadReportMyHarvest',
    props: {
      harvest: {
        validator(val) {
          return validator.isObject(val);
        },
        required: true,
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .million-read-report-my-harvest {
    box-sizing: border-box;
    padding-bottom: 80px;
    background: @color-white;
    width: 750px;
    margin: 0 auto;

    &-header {
      width: 750px;
      height: 250px;
      background: url('~@/assets/img/million_read/report_harvest_header.png') #f4f4f4 no-repeat;
      background-size: contain;
      &-title {
        box-sizing: border-box;
        position: relative;
        margin-bottom: @size-medium;
        padding: 64px 0 0 48px;
        color: @color-text-base;
        font-size: @font-size-extra-large;
        font-weight: @font-weight-strong;
        line-height: 1;
        &:after {
          position: absolute;
          z-index: 1;
          bottom: -6px;
          left: 40px;
          width: 176px;
          height: 20px;
          content: '';
          background: #fed100;
          border-radius: 5px;
        }
        span {
          position: relative;
          z-index: 2;
        }
      }
    }
    &-list {
      box-sizing: border-box;
      margin-top: -84px;
      padding: 0 @size-medium;
    }
    &-item {
      &:not(:last-child) {
        margin-bottom: 80px;
      }
      &-title {
        box-sizing: border-box;
        position: relative;
        margin-bottom: 16px;
        padding-left: 16px;
        color: @color-text-base;
        font-size: 34px;
        line-height: 1;
        &:before {
          position: absolute;
          top: 24px;
          left: 0;
          width: 8px;
          height: 32px;
          content: '';
          background: #222;
          border-radius: 2px;
        }
        /deep/ .highlight {
          display: inline;
          font-size: 64px;
          font-weight: @font-weight-strong;
          line-height: 1;
        }
      }
      &-content {
        color: @color-text-lighter;
        font-size: 26px;
        line-height: 1.5;
      }
    }
  }

</style>
